var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/package_box.89e85507.png","uri@2x": __webpack_public_path__ + "static/media/package_box.332b93bf.png","uri@3x": __webpack_public_path__ + "static/media/package_box.b3b6c574.png",
    width: 40,
    height: 41
});